import { Link } from 'react-router-dom';
import { Container } from '@/components/ui/Container';
import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation();

  const footerLinks = {
    product: [
      { label: t('nav.features'), href: '/#features' },
      { label: t('nav.pricing'), href: '/#pricing' },
      { label: t('nav.comparison'), href: '/#comparison' },
    ],
    company: [
      { label: t('nav.blog'), href: '#', disabled: true },
      { label: t('nav.contact'), href: 'mailto:hola@affogato.cloud' },
    ],
    legal: [
      { label: t('nav.privacy'), href: '/privacidad', isRoute: true },
      { label: t('nav.terms'), href: '/terminos', isRoute: true },
    ],
  };

  return (
    <footer className="bg-gray-50 dark:bg-slate-900 border-t border-gray-200 dark:border-slate-800">
      <Container>
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {/* Brand */}
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <img src="/logo.svg" alt="Affogato" className="w-8 h-8" />
                <span className="text-xl font-bold text-gray-900 dark:text-white">
                  Affogato
                </span>
              </Link>
              <p className="text-gray-600 dark:text-slate-400 text-sm">
                {t('footer.description')}
              </p>
            </div>

            {/* Product Links */}
            <div>
              <h3 className="font-semibold text-gray-900 dark:text-white mb-4">
                {t('nav.product')}
              </h3>
              <ul className="space-y-3">
                {footerLinks.product.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-gray-600 hover:text-gray-900 dark:text-slate-400 dark:hover:text-white text-sm transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company Links */}
            <div>
              <h3 className="font-semibold text-gray-900 dark:text-white mb-4">
                {t('nav.company')}
              </h3>
              <ul className="space-y-3">
                {footerLinks.company.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className={`text-sm transition-colors ${
                        link.disabled
                          ? 'text-gray-400 dark:text-slate-600 cursor-not-allowed'
                          : 'text-gray-600 hover:text-gray-900 dark:text-slate-400 dark:hover:text-white'
                      }`}
                    >
                      {link.label}
                      {link.disabled && (
                        <span className="ml-2 text-xs text-gray-400">{t('nav.blogComingSoon')}</span>
                      )}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Legal Links */}
            <div>
              <h3 className="font-semibold text-gray-900 dark:text-white mb-4">
                {t('nav.legal')}
              </h3>
              <ul className="space-y-3">
                {footerLinks.legal.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-gray-600 hover:text-gray-900 dark:text-slate-400 dark:hover:text-white text-sm transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Bottom */}
          <div className="mt-12 pt-8 border-t border-gray-200 dark:border-slate-800">
            <p className="text-gray-500 dark:text-slate-500 text-sm text-center">
              &copy; {new Date().getFullYear()} Affogato. {t('common.allRightsReserved')}
            </p>
          </div>
        </div>
      </Container>
    </footer>
  );
}
